import React, { useEffect, useRef } from 'react';
import { InformationPanel } from './Inventory/Inventory';
import './Inventory/Inventory.css';
import DraggableModal from './Modal/DraggableModal';

function AuctionInfoModal({ open, itemInfo, onClose }) {
    const modalRef = useRef(null);

    if (!open || !itemInfo) return null;

    return (
        <DraggableModal modalId="auctioninfo" onClose={onClose}>
            <div className="modal-content" style={{ width: '500px' }} ref={modalRef}>
                <div className="tmodal-header">
                    <span className="close" onClick={onClose}>&times;</span>
                    <h2>Auction Info</h2>
                </div>
                <div className="modal-body" style={{ width: '100%', padding: '2px 5px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                        {itemInfo.picId !== undefined && (
                            <img 
                                src={require(`../Assets/gfx/${itemInfo.picId}.webp`)} 
                                alt="item" 
                                style={{ width: 48, height: 48, marginRight: 12, border: '1px solid #333', borderRadius: 6 }}
                                onError={e => { e.target.src = require('../Assets/gfx/1.webp'); }}
                            />
                        )}
                        <span style={{ fontWeight: 600, fontSize: '1.2em' }}>{itemInfo.name}</span>
                    </div>
                    <InformationPanel itemInfo={itemInfo} />
                </div>
                <div className="modal-footer">
                    <button className="ts-close" onClick={onClose}>Close</button>
                </div>
            </div>
        </DraggableModal>
    );
}

export default AuctionInfoModal; 